export default __webpack_public_path__ + "static/media/151-carrier.443cc02a.png";